// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__fallbackMessage {
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  font-family: 'Courier New', Courier, monospace;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__textNewArrivals {
  color: white;
  position: absolute;
  top: 0.5rem;
  left: 3.3rem;
  font-size: 20px;
  font-family: 'Courier New', Courier, monospace;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__skeletonContainer {
  background-color: white;
  margin: 1.25rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 18rem;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__viewport {
  overflow: hidden;
  background-color: white;
  margin: 1.25rem;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__container {
  display: flex;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -webkit-tap-highlight-color: transparent;
  margin-left: -2rem;
  margin-right: 2rem;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__viewport__small {
  min-width: -moz-fit-content;
  min-width: fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin: 1.25rem auto;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__viewport__small .app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__container {
    margin-left: -0.5rem;
    margin-right: 2rem;
  }

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__slide {
  flex: 0 0 var(--slide-size);
  min-width: 0;
  max-width: 13.75rem;
  padding-left: var(--slide-spacing);
  position: relative;
  margin: 1rem;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cards {
  min-width: 12.5rem;
  margin: 1rem;
  min-height: 13.13rem;
  height: 13.13rem;
  transition: all 0.1s;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cards:hover {
    box-shadow: 0px 3px 15px 3px rgba(0, 0, 0, 0.5);
  }

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cards .app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__media {
    height: 5rem;
    width: 5rem;
    border-radius: 50%;
    margin: 0.63rem auto;
    border: 1px solid grey;
  }

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cards .app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cardContent {
    padding-left: 20px;
    color: white;
    height: 8.13rem;
  }

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cards .app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cardContent .app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__title {
      text-transform: capitalize;
      font-weight: bold;
      font-size: 14px;
    }

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cards .app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cardContent .app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__text {
      text-transform: capitalize;
      font-size: 14px;
    }

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__button {
  outline: 0;
  cursor: pointer;
  background-color: transparent;
  touch-action: manipulation;
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  fill: white;
  padding: 0;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__button:disabled {
  cursor: default;
  opacity: 0.3;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__button__svg {
  width: 100%;
  height: 100%;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__button_prev {
  left: 24px;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__button_next {
  right: 24px;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__dots {
  display: flex;
  list-style: none;
  justify-content: center;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__dot {
  background-color: transparent;
  cursor: pointer;
  position: relative;
  padding: 0;
  outline: 0;
  border: 0;
  width: 30px;
  height: 30px;
  margin-right: 7.5px;
  margin-left: 7.5px;
  display: flex;
  align-items: center;
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__dot:after {
  background-color: #efefef;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  content: '';
}

.app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__isSelected:after {
  background-color: var(--colors-yuzu-primaryColor);
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./app/components/OrganizationChart/GlobalPage/EmblaCarousel.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EACxB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,2BAAsB;EAAtB,sBAAsB;EACtB,oBAAoB;AAMtB;;AAJE;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;AAGF;EACE,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AA8BtB;;AA5BE;IACE,+CAA+C;EACjD;;AAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;EACxB;;AAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;EAYjB;;AAVE;MACE,0BAA0B;MAC1B,iBAAiB;MACjB,eAAe;IACjB;;AAEA;MACE,0BAA0B;MAC1B,eAAe;IACjB;;AAIJ;EACE,UAAU;EACV,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iDAAiD;EACjD,UAAU;AACZ","sourcesContent":[".fallbackMessage {\n  color: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 20px;\n  font-family: 'Courier New', Courier, monospace;\n}\n\n.textNewArrivals {\n  color: white;\n  position: absolute;\n  top: 0.5rem;\n  left: 3.3rem;\n  font-size: 20px;\n  font-family: 'Courier New', Courier, monospace;\n}\n\n.skeletonContainer {\n  background-color: white;\n  margin: 1.25rem auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 18rem;\n  width: 50%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.embla__viewport {\n  overflow: hidden;\n  background-color: white;\n  margin: 1.25rem;\n}\n\n.embla__container {\n  display: flex;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -khtml-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  margin-left: -2rem;\n  margin-right: 2rem;\n}\n\n.embla__viewport__small {\n  min-width: fit-content;\n  max-width: fit-content;\n  margin: 1.25rem auto;\n\n  .embla__container {\n    margin-left: -0.5rem;\n    margin-right: 2rem;\n  }\n}\n\n.embla__slide {\n  flex: 0 0 var(--slide-size);\n  min-width: 0;\n  max-width: 13.75rem;\n  padding-left: var(--slide-spacing);\n  position: relative;\n  margin: 1rem;\n}\n\n.cards {\n  min-width: 12.5rem;\n  margin: 1rem;\n  min-height: 13.13rem;\n  height: 13.13rem;\n  transition: all 0.1s;\n\n  &:hover {\n    box-shadow: 0px 3px 15px 3px rgba(0, 0, 0, 0.5);\n  }\n\n  .media {\n    height: 5rem;\n    width: 5rem;\n    border-radius: 50%;\n    margin: 0.63rem auto;\n    border: 1px solid grey;\n  }\n\n  .cardContent {\n    padding-left: 20px;\n    color: white;\n    height: 8.13rem;\n\n    .title {\n      text-transform: capitalize;\n      font-weight: bold;\n      font-size: 14px;\n    }\n\n    .text {\n      text-transform: capitalize;\n      font-size: 14px;\n    }\n  }\n}\n\n.embla__button {\n  outline: 0;\n  cursor: pointer;\n  background-color: transparent;\n  touch-action: manipulation;\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 0;\n  width: 30px;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n  fill: white;\n  padding: 0;\n}\n\n.embla__button:disabled {\n  cursor: default;\n  opacity: 0.3;\n}\n\n.embla__button__svg {\n  width: 100%;\n  height: 100%;\n}\n\n.embla__button_prev {\n  left: 24px;\n}\n\n.embla__button_next {\n  right: 24px;\n}\n\n.embla__dots {\n  display: flex;\n  list-style: none;\n  justify-content: center;\n}\n\n.embla__dot {\n  background-color: transparent;\n  cursor: pointer;\n  position: relative;\n  padding: 0;\n  outline: 0;\n  border: 0;\n  width: 30px;\n  height: 30px;\n  margin-right: 7.5px;\n  margin-left: 7.5px;\n  display: flex;\n  align-items: center;\n}\n\n.embla__dot:after {\n  background-color: #efefef;\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  content: '';\n}\n\n.isSelected:after {\n  background-color: var(--colors-yuzu-primaryColor);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fallbackMessage": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__fallbackMessage`,
	"textNewArrivals": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__textNewArrivals`,
	"skeletonContainer": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__skeletonContainer`,
	"embla__viewport": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__viewport`,
	"embla__container": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__container`,
	"embla__viewport__small": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__viewport__small`,
	"embla__slide": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__slide`,
	"cards": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cards`,
	"media": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__media`,
	"cardContent": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__cardContent`,
	"title": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__title`,
	"text": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__text`,
	"embla__button": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__button`,
	"embla__button__svg": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__button__svg`,
	"embla__button_prev": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__button_prev`,
	"embla__button_next": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__button_next`,
	"embla__dots": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__dots`,
	"embla__dot": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__embla__dot`,
	"isSelected": `app-components-OrganizationChart-GlobalPage-___EmblaCarousel-module__isSelected`
};
export default ___CSS_LOADER_EXPORT___;
